var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #393939;\n        stroke: #393939;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 75,
    height: 75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.97 72.03 22.6 64.36 11.64 53.4 3.97 72.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "47.52 17.17 13.32 51.37 24.63 62.68 58.47 28.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.6,
    y: 0,
    width: 16,
    height: 66.82,
    transform: "translate(49.1 87.14) rotate(-135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.71,
    y: 7.29,
    width: 16,
    height: 16,
    transform: "translate(92.84 69.03) rotate(-135)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit-Icon.7e7e77f0100b0cfde583c12716ed3778.svg";
export { ForwardRef as ReactComponent };